/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Quick Add
 * @returns {Func} init
 */
function quickAdd() {
  const c = {
    dom: {
      default_input: '.js-variant-select',
      options_container: '.js-quick-add-variant-options',
      options: '.js-quick-add-variant-option',
      submit: '.js-quick-add-value',
      button: '.js-quick-add-btn',
      quickShop: '.js-quick-shop',
      selectWrapper: '.js-quick-select-wrapper',
      closeButton: '.js-quick-add-close'
    },
    cls: {
      active: 'show-option',
    }
  };

  const $selectInputDefault = document.querySelectorAll(`${c.dom.default_input}`);
  const $optionContainer = document.querySelectorAll(`${c.dom.options_container}`);
  const $options = document.querySelectorAll(`${c.dom.options}`);
  const $sendValues = document.querySelectorAll(`${c.dom.submit}`);
  const $sendButton = document.querySelectorAll(`${c.dom.button}`);
  const $quickShop = document.querySelectorAll(`${c.dom.quickShop}`);
  const $selectWrapper = document.querySelectorAll(`${c.dom.selectWrapper}`);
  const $closeButton = document.querySelectorAll(`${c.dom.closeButton}`);

  function init() {


    Array.from($selectInputDefault).forEach(($selector, index) => {

      $quickShop.forEach((button, index) => {
        button.addEventListener('click', () => {
          $selectWrapper[index].classList.add('show-opts');
          $selectWrapper[index].addEventListener('blur', () => $selectWrapper[index].classList.remove('show-opts'));
        });
      })
      $selector.addEventListener('click', (event) => {
        $optionContainer[index].classList.toggle(`${c.cls.active}`);
        const $activeContainer = $optionContainer[index];
        const $activeInput = $sendValues[index];
        const $activeButton = $sendButton[index];
        const $activeClose = $closeButton[index];
        $activeClose.innerHTML == "X" ?  $activeClose.innerHTML = '+' : $activeClose.innerHTML = '-';

        $options.forEach(($option) => {
          $option.addEventListener('click', (event) => {
            $selector.innerHTML = event.target.innerText;
            $activeContainer.classList.toggle(`${c.cls.active}`);
            $activeInput.value = event.target.dataset.id;
            $activeButton.disabled = false;
          })
        })
      })
    })
  }
  return init();
}
quickAdd();
